export default "__VITE_ASSET__d35813dd__"